// Shared phone-number helpers for the SPA. Mirrors the backend policy
// (apps/phone.py): every phone is a canonical E.164 string. These wrap
// libphonenumber-js (bundled with react-phone-number-input) so display
// + validation stay consistent everywhere.
import {
  isValidPhoneNumber,
  formatPhoneNumberIntl,
} from "react-phone-number-input";

/** True when `v` is a complete, valid international number. */
export function isValidPhone(v?: string | null): boolean {
  if (!v) return false;
  try {
    return isValidPhoneNumber(v);
  } catch {
    return false;
  }
}

/** Pretty international form (e.g. "+33 6 12 34 56 78") for read views.
 *  Falls back to the raw value when it can't be parsed (legacy data). */
export function displayPhone(v?: string | null): string {
  if (!v) return "";
  try {
    return formatPhoneNumberIntl(v) || v;
  } catch {
    return v;
  }
}
